"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TabContent = _interopRequireDefault(require("reactstrap/lib/TabContent"));

var _TabPane = _interopRequireDefault(require("reactstrap/lib/TabPane"));

var _Nav = _interopRequireDefault(require("reactstrap/lib/Nav"));

var _NavItem = _interopRequireDefault(require("reactstrap/lib/NavItem"));

var _NavLink = _interopRequireDefault(require("reactstrap/lib/NavLink"));

var _utils = require("../lib/utils");

require("./tab.css");

var DefaultTab = function DefaultTab(props) {
  var dataTestId = props.dataTestId,
      tabbar = props.tabbar,
      items = props.items,
      onTabClick = props.onTabClick,
      tabContentTestId = props.tabContentTestId,
      activeTabId = props.activeTabId,
      leftAligned = props.leftAligned,
      borderBottom = props.borderBottom,
      noBorderBottomTab = props.noBorderBottomTab,
      navItemClass = props.navItemClass,
      navLinkClass = props.navLinkClass,
      bodyClass = props.bodyClass;
  var horizontal = !leftAligned ? "center" : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props)
  }, /*#__PURE__*/_react["default"].createElement(_Nav["default"], {
    tabs: true,
    className: (0, _utils.gatherClasses)(null, tabbar && !borderBottom || noBorderBottomTab ? "oui-no-border" : null),
    horizontal: horizontal
  }, (0, _map["default"])(items).call(items, function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
      key: index,
      className: navItemClass
    }, (0, _utils.isFunction)(tab.renderComponent) ? tab.renderComponent(tab, index, "oui-active", "oui-nav-link") : /*#__PURE__*/_react["default"].createElement(_NavLink["default"], {
      href: "#",
      className: (0, _utils.gatherClasses)(null, activeTabId === tab.id ? "oui-active" : null, tab.isInvalid ? "oui-is-invalid" : null, navLinkClass),
      onClick: function onClick() {
        if ((0, _utils.isFunction)(onTabClick)) {
          onTabClick(tab);
        }
      }
    }, tab.title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "oui-highlighter"
    }));
  })), tabbar ? null : /*#__PURE__*/_react["default"].createElement(_TabContent["default"], {
    "data-testid": tabContentTestId || "orion-tab-content",
    activeTab: activeTabId,
    className: bodyClass
  }, (0, _map["default"])(items).call(items, function (tab, index) {
    return /*#__PURE__*/_react["default"].createElement(_TabPane["default"], {
      tabId: tab.id,
      key: index
    }, (0, _utils.isFunction)(tab.component) ? tab.component(tab.id, tab.title) : null);
  })));
};

DefaultTab.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: (0, _utils.requiredIf)(_propTypes["default"].string, function (props) {
      return !(0, _utils.isFunction)(props.renderComponent);
    }),
    title: (0, _utils.requiredIf)(_propTypes["default"].string, function (props) {
      return !(0, _utils.isFunction)(props.renderComponent);
    }),
    isInvalid: _propTypes["default"].bool,
    component: _propTypes["default"].func,
    renderComponent: _propTypes["default"].func
  })).isRequired,
  activeTabId: _propTypes["default"].string,
  onTabClick: _propTypes["default"].func,
  tabbar: _propTypes["default"].bool,
  dataTestId: _propTypes["default"].string,
  tabContentTestId: _propTypes["default"].string,
  leftAligned: _propTypes["default"].bool,
  borderBottom: _propTypes["default"].bool,
  navItemClass: _propTypes["default"].string,
  navLinkClass: _propTypes["default"].string,
  bodyClass: _propTypes["default"].string,
  noBorderBottomTab: _propTypes["default"].bool
};
DefaultTab.defaultProps = {
  tabbar: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  items: [],
  dataTestId: "orion-tabs",
  leftAligned: false,
  noBorderBottomTab: false
};
DefaultTab.displayName = "OrionCoreTab";
var _default = DefaultTab;
exports["default"] = _default;